import type { CompanyGuid, ContactUpserterDTO } from '@breezy/shared'

export type AdditionalEmailAddressPayload = ContactUpserterDTO['additionalEmailAddress']
type ExistingAdditionalEmailAddress = Exclude<AdditionalEmailAddressPayload, null | undefined>

type BuildAdditionalEmailPayloadInput = {
  value?: string
  touched: boolean
  visible: boolean
  existing?: ExistingAdditionalEmailAddress
  companyGuid: CompanyGuid
  guidFactory: () => string
}

export const buildAdditionalEmailPayload = ({
  value,
  touched,
  visible,
  existing,
  companyGuid,
  guidFactory,
}: BuildAdditionalEmailPayloadInput): AdditionalEmailAddressPayload => {
  if (value) {
    return {
      emailAddressGuid: existing?.emailAddressGuid ?? guidFactory(),
      companyGuid: existing?.companyGuid ?? companyGuid,
      emailAddress: value,
    }
  }

  if (!visible && existing) {
    return existing
  }

  if (visible && touched) {
    return null
  }

  return undefined
}
